import React from 'react';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <header className="app-header">
        <h1>My Website</h1>
        <nav className="navbar">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <section id="home" className="hero-section">
        <h2>Welcome to My Website</h2>
        <p>We offer modern solutions to grow your business.</p>
      </section>

      <section id="about" className="about-section">
        <h2>About Us</h2>
        <p>
          We are a passionate team focused on delivering high-quality digital services, including web development,
          mobile apps, and cloud solutions. Our mission is to drive digital success for our clients.
        </p>
      </section>

      <section id="services" className="services-section">
        <h2>Our Services</h2>
        <ul>
          <li>🌐 Website Development</li>
          <li>📱 Mobile App Development</li>
          <li>☁️ Cloud Consulting</li>
          <li>🛠️ Software Maintenance</li>
        </ul>
      </section>

      <section id="contact" className="contact-section">
        <h2>Contact Us</h2>
        <p>Email: contactinfocentre@gmail.com</p>
        <p>Phone: +91 98765 43210</p>
      </section>

      <footer className="app-footer">
        <p>&copy; 2025 My Website. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;
